var Stepper = function Stepper(_ref) {
  var colors = _ref.colors,
      spacing = _ref.spacing,
      fontSizes = _ref.fontSizes,
      fontWeights = _ref.fontWeights,
      radii = _ref.radii;
  return {
    padding: {
      left: spacing.xxlarge,
      right: spacing.xxlarge
    },
    line: {
      backgroundColor: {
        active: colors.primary,
        inactive: colors.elements.backgroundAndDisabled
      }
    },
    dot: {
      radius: radii.circle,
      backgroundColor: {
        active: colors.primary,
        inactive: colors.elements.backgroundAndDisabled
      }
    },
    label: {
      font: {
        weight: fontWeights.bold,
        size: fontSizes.xsmall
      },
      color: {
        active: colors.primary,
        inactive: colors.elements.selectionAndIcons
      }
    }
  };
};

export default Stepper;